import { animate, style, transition, trigger } from "@angular/animations";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";


@Component({
    selector: 'alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss'],
    animations: [
        trigger('opacity', [
            transition(':enter', [
                style({ opacity: '0' }),
                animate('100ms ease-in', style({ opacity: '1' })),
            ]),
            transition(':leave', [
                style({ opacity: '1' }),
                animate('200ms ease-in', style({ opacity: '0' })),
            ]),
        ]),
    ],
    standalone: false
})
export class AlertDialogComponent {
  @Input() visible: boolean = false;
  @Input() type: 'error' | 'info' | 'warning' = 'info';
  @Input() message: string = '';

  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public translateService: TranslateService
  ) {
    this.message = config.data.message;
    
    this.type = config.data.type || 'info';
    this.header = config.data.header;
  }
  okBtnText: string = 'translate.alert.approve';
  cancelBtnText: string = 'translate.alert.cancel';
  header: string = '';

  get dialogTitle(): string {
    switch (this.type) {
      case 'error': return 'Error';
      case 'warning': return 'Warning';
      default: return 'Info';
    }
  }

  get icon(): string {
    switch (this.type) {
      case 'error': return 'fa-exclamation-triangle';
      case 'warning': return 'pi pi-exclamation-triangle';
      default: return 'pi pi-info-circle';
    }
  }

  get headerClass(): string {
    return `dialog-header-${this.type}`;
  }

  onClose() {
    this.close.emit();
  }


  onOk() {
    this.ref.close();
    this.close.emit();

  }
}